import { render, staticRenderFns } from "./Review_organization.vue?vue&type=template&id=59a73208&scoped=true"
import script from "./Review_organization.vue?vue&type=script&lang=js"
export * from "./Review_organization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a73208",
  null
  
)

export default component.exports